import { render, staticRenderFns } from "./ClientPortfolioActions.vue?vue&type=template&id=a476144e&"
import script from "./ClientPortfolioActions.vue?vue&type=script&lang=js&"
export * from "./ClientPortfolioActions.vue?vue&type=script&lang=js&"
import style0 from "./ClientPortfolioActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports